import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { ContractTypeGroupModel } from './../models/contracttypegroup.model';
import { ContractTypeGroupService } from './../models/contracttypegroup.service';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { VehicleModel } from '../../vehicle/models/vehicle.model';
import {
  WeGoConfig,
  ApplicationRouteURL,
  IAPIResponse,
  IKeyValueInterface,
  RoleLevel
} from '../../shared/config';
import { Location } from '@angular/common';
import { DropdownModel } from '../../report/models/report-filter.model';
import { VatDefaultModel } from '../../vat-setting/models/vat-settings.model';

@Component({
  selector: 'wego-contracttypegroup-update',
  template: require('../views/contracttypegroup-update.component.html'),
  providers: [ContractTypeGroupService]
})
export class ContractTypeGroupUpdateComponent implements OnInit, OnDestroy {
  sub: any;
  submitted = false;
  model: ContractTypeGroupModel;
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlcontractTypeGroupList: string;
  urlSVGList: string;
  contractTypeGroupHashId: string;
  sharedVehicleGroupHashId: string;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  private sharedvehicleGroup: string;
  penaltyTimeInterval: any;
  roleLevel = RoleLevel;
  vatSettingList: DropdownModel[];
  vatSettingDefaultValues: VatDefaultModel;
  @ViewChild('successPopup') public successPopup: any;

  constructor(
    private contracttypegroupService: ContractTypeGroupService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.penaltyTimeInterval = [
      {
        Key: 'Per 5 Minute',
        Value: '5'
      },
      {
        Key: 'Per 10 Minute',
        Value: '10'
      },
      {
        Key: 'Per 15 Minute',
        Value: '15'
      }
    ];
    this.module = this.translate.instant('LblContractTypeGroup');
    this.sharedvehicleGroup = this.translate.instant('LblListPage', [
      this.translate.instant('LblSharedVehicleGroup')
    ]);
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlcontractTypeGroupList = this.authService.GetURL(
      ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST
    );
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.model = new ContractTypeGroupModel();
    this.GetContractTypeGroupDetails();
  }

  public GetContractTypeGroupDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.contractTypeGroupHashId = params['ctgHashId'] || ''; // contractTypeGroupHashId
      this.sharedVehicleGroupHashId = params['svgHashId'] || '';
      this.GetVatSettingDropdownList();
      if (this.contractTypeGroupHashId != '') {
        this.isEditMode = true;
        this.contracttypegroupService
          .GetContractTypeGroupByHashId(this.contractTypeGroupHashId)
          .subscribe(
            res => {
              (this.model = res.data),
                (this.sharedVehicleGroupHashId = this.model.sharedVehicleGroupHashId);
              this.model.penaltyTimeInterval = this.model.penaltyTimeInterval
                ? this.model.penaltyTimeInterval
                : this.penaltyTimeInterval[0].Value;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
          );
      } else {
        this.isEditMode = false;
        this.model = new ContractTypeGroupModel();
        this.model.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
        this.model.penaltyTimeInterval = this.penaltyTimeInterval[0].Value;
        this.GetCurrencyByGroup();
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant('LblEditPage', [this.module])
      : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  onSubmit(forms: any) {
    this.submitted = true;
    this.AddNewContractTypGroup();
  }

  public GetCurrencyByGroup() {
    this.contracttypegroupService
      .GetCurrencyByGroup(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.model.currencySymbol = res.data.currencySymbol;
            this.model.isCurrencySymbolBefore =
              res.data.currencySignBeforeAmount;
          } else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public AddNewContractTypGroup() {
    this.contracttypegroupService.AddContractType(this.model).subscribe(
      (res: any) => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant('LblRecordUpdatedSuccess', [this.module])
            : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetVatSettingDefaultValues() {
    this.contracttypegroupService
      .GetVatSettingDefaultValues(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.vatSettingDefaultValues = res.data;
            this.model.penaltyVat = this.vatSettingDefaultValues.defaultVatPenaltyCost;
            this.model.vatSettingDefaultCost = this.vatSettingDefaultValues.vatSettingDefaultCost;
          } else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetVatSettingDropdownList() {
    this.contracttypegroupService
      .GetVatSettingDropdownList(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.vatSettingList = res.data;
            if (!this.isEditMode) this.GetVatSettingDefaultValues();
          } else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  onChangePenaltyInterval(value: any) {
    this.model.penaltyTimeInterval = value;
  }
  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant('LblExcludingVat')
      : this.translate.instant('LblIncludingVat');
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contracttypegroup/components/contracttypegroup-update.component.ts